<template>
  <div class="container page funds-page">
    <van-nav-bar :title="$t('frontend.funds.title')" class="nav-bar">
      <template #left><button type="button" class="funds-back" :aria-label="$t('frontend.funds.back_account')" @click="$router.push('/Mine')"><van-icon name="arrow-left" color="#fff" /></button></template>
    </van-nav-bar>
    <main class="funds-menu">
      <van-cell :title="$t('frontend.funds.usdt_address')" is-link to="/BindUsdt" />
    </main>
  </div>
</template>

<script>
export default {
  created() {
    if (!localStorage.getItem('token')) this.$router.replace('/Login');
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
@import "../../assets/css/funds.less";
.funds-menu ::v-deep .van-cell { min-height: 96px; padding: 26px 32px; color: #333; font-size: 34.56px; line-height: 44px; }
.funds-menu ::v-deep .van-cell__right-icon { height: 44px; font-size: 32px; line-height: 44px; }
.funds-menu ::v-deep .van-cell::after { left: 16px; right: 16px; }
</style>
